import React, { useEffect } from "react";
import { Badge } from "primereact/badge";
import { Avatar } from "primereact/avatar";
import { ProgressSpinner } from "primereact/progressspinner";
import "./NotificationPanelContentStyle.scss";
import graydot from "../../Assets/graydot.png";
import { useDispatch, useSelector } from "react-redux";
import { fetchNotifications } from "../../Store/Dashboard/DashboardActions";
import * as dashboardSelectors from "../../Store/Dashboard/DashboardSelectors";
const NotificationItem = ({ notification }) => (
  <div className="notification-item">
    <div className="flex align-items-center">
      <div>
        {notification.firstname && notification.lastname ? (
          <Avatar
            label={notification.firstname[0] + notification.lastname[0]}
            style={{ backgroundColor: "#E2E2E2", color: "#333333" }}
            shape="circle"
          />
        ) : (
          <Avatar
            label={""}
            style={{ backgroundColor: "#E2E2E2", color: "#333333" }}
            shape="circle"
          />
        )}
      </div>
      <p
        className="font-semibold"
        style={{ marginLeft: "1rem", width: "fit-content" }}
      >
        {" "}
        {notification.firstname} {notification.lastname} :{" "}
        <span className="font-normal">{notification.discription}</span>
      </p>
    </div>
    <div className="flex align-items-center justify-content-start">
      <div className="text-xs">
        <img
          src={graydot}
          alt="gray-dot"
          style={{ marginLeft: "2.4rem", marginRight: "0.5rem" }}
        />
        {notification.timeAgo}
      </div>
    </div>
  </div>
);
const NotificationPanelContent = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchNotifications());
  }, [dispatch]);
  const notifications = useSelector(dashboardSelectors.getNotifications);
  const dataLoading = useSelector(dashboardSelectors.getIsNotLoading);

  return (
    <div>
      <div>
        <div
          className="h-5rem ml-2"
          style={{ borderBottom: "1px solid #E2E2E2" }}
        >
          <div className="flex">
            <div className="mt-3 text-blue-900 text-base">Notification</div>
            {notifications && notifications.Today && (
              <div className="ml-2 mt-3">
                <Badge
                  value={`${notifications["Today"].length} new`}
                  style={{
                    backgroundColor: "#2C3D8F",
                    fontWeight: 400,
                    fontSize: "5px",
                  }}
                  severity="info"
                ></Badge>
              </div>
            )}
          </div>
          {/* <div
            className="text-blue-700"
            style={{ marginTop: "1rem", marginLeft: "16rem" }}
          >
            Mark as all read
          </div> */}
        </div>
        {dataLoading ? (
          <div className="align-items-center justify-content-center spinnerstyle">
            <ProgressSpinner />
          </div>
        ) : (
          <div>
            {notifications &&
              Object.keys(notifications).map((category) => (
                <div key={category}>
                  <div className="p-3" style={{ backgroundColor: "#f8f9fa" }}>
                    <div style={{ marginLeft: "0.5rem" }}>
                      {category.toUpperCase()}
                    </div>
                  </div>
                  {notifications[category].map((notification, index) => (
                    <NotificationItem
                      key={notification}
                      notification={notification}
                    />
                  ))}
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationPanelContent;
